import { render, staticRenderFns } from "./ChosenCategoryCard.vue?vue&type=template&id=cf4a9ba6&"
import script from "./ChosenCategoryCard.vue?vue&type=script&lang=js&"
export * from "./ChosenCategoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShowcasesChosenCategoryCardInner: require('/usr/src/motec/components/showcases/ChosenCategoryCardInner.vue').default})
